import React from 'react';
import { motion } from 'framer-motion';
import Modal from './Modal.jsx';
import Button from './Button.jsx';
import { AlertTriangle } from 'lucide-react';

function ConfirmDialog({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  type = 'danger',
  confirmText = 'Confirm',
  loading = false 
}) {
  const typeConfig = {
    danger: {
      icon: AlertTriangle,
      iconColor: 'text-red-400',
      confirmVariant: 'danger'
    },
    warning: {
      icon: AlertTriangle,
      iconColor: 'text-yellow-400',
      confirmVariant: 'primary'
    },
    info: {
      icon: AlertTriangle,
      iconColor: 'text-blue-400',
      confirmVariant: 'primary'
    }
  };

  const config = typeConfig[type];
  const Icon = config.icon;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.1 }}
          className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-700 mb-4"
        >
          <Icon className={`h-6 w-6 ${config.iconColor}`} />
        </motion.div>
        
        <p className="text-gray-300 mb-6">
          {message}
        </p>
        
        <div className="flex space-x-3">
          <Button
            variant="secondary"
            onClick={onClose}
            className="flex-1"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant={config.confirmVariant}
            onClick={onConfirm}
            loading={loading}
            className="flex-1"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;